<template>
    <v-container>
        <v-row align="center" justify="center">
            <template v-if="message">
                <v-col class="col-12" align="center" justify="center">
                    <i class="fas fa-check-circle fa-5x" style="color:green;" v-if="success"></i>
                    <i class="fas fa-exclamation-circle fa-5x" style="color:red;" v-if="!success"></i>     
                    <br><br>
                    {{message}}
                </v-col>
            </template>

            <template v-else>Logger ut.. <i class="fas fa-spinner fa-5x fa-spin"></i></template>
        </v-row>
    </v-container>
</template>
<script>
import { apiUrl } from '../api'
export default {
    data(){
        return {
            message: null,
            success: false
        }
    },
    async mounted(){
        if(localStorage.getItem('apiKey')){
            let resp = await fetch(apiUrl+"/../auth/logout", {headers:{Token:localStorage.getItem('apiKey')}})
            if(resp.status == 200){
                let data = await resp.json()
                if(data == "ok"){
                    localStorage.removeItem('apiKey')
                    this.success = true
                    this.message = "Du har blitt logget ut. Nå kan du trygt lukke denne vindu."
                    return;
                }
            }
            this.message = "Feilet å logge ut."
        }else {
            this.success = true
            this.message = "Allerede logget ut. Du kan lukke denne vindu."
        }
        
    }
}
</script>